import {useFormContext as useFormContextOriginal} from '../../lib/react-hook-form';
import type {FieldValues, UseFormReturn} from './types';

export function useFormContext<
  TFieldValues extends FieldValues = FieldValues,
>(): UseFormReturn<TFieldValues> {
  const fullMethods = useFormContextOriginal<TFieldValues>();

  if (!fullMethods || !('__sailFormContext' in fullMethods)) {
    return null;
  }

  // Extract public methods (hide handleSubmit and rename trigger)
  const {handleSubmit, trigger, subscribe, ...publicMethods} = fullMethods;

  return {
    ...publicMethods,
    validate: trigger,
    field: (name, rules) => ({name, rules}),
    __internal: {
      handleSubmit,
      subscribe,
    },
  };
}
